import angular from 'angular';
import {
  emDataService,
  orgDataService,
  userService

} from 'app/services';

import caEditCustomerSettings from '../editCustomerSettings';
import caCustomerServices from '../services';
import caEditCustomerLogo from '../editCustomerLogo';
import caEditCustomerAzure from '../editCustomerAzure';

import controller from './edit-customer.directive.controller';
import directive from './edit-customer.directive';


export default angular.module('app.components.admin.customerAdministration.editCustomer', [
  userService,
  orgDataService,
  emDataService,
  caEditCustomerSettings,
  caCustomerServices,
  caEditCustomerLogo,
  caEditCustomerAzure
])
  .directive('caEditCustomer', directive)
  .controller('CAEditCustomerDirectiveController', controller)
  .name;

console.log('app.components.admin.customerAdministration.editCustomer created');
